import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface CupomEstabelecimentoItem {
    id: number
    cupomId: number
    nomeCupom: string
    valor: number
    percentual: boolean
    quantidadePorCliente: number
    quantidadeMaxima: number | null
    valorMinimoPedido: number | null
    maximoDesconto: number | null
    apenasPrimeiraCompra: boolean
    automatico: boolean
    ativo: boolean
    freteGratis: boolean
    appSiteTodos: number
    validadeDias: number | null
    fimCupomTimestamp: number | null
    visivelTelaInicial: boolean
    horarioAlmoco: boolean
    exigirFacebookParaDesconto: boolean
    exigirEnderecoUnicoParaDesconto: boolean
    exigirCpfParaDesconto: boolean
    telefoneCliente: string | null
    descricao: string
    olharListaClientes: boolean
    quantidadeUtilizada: number
}

export interface SalvarCuponsPayload {
    cupons: {
        id: number | null
        cupomId: number | null
        nomeCupom: string
        valor: number
        percentual: boolean
        quantidadePorCliente: number
        quantidadeMaxima: number | null
        valorMinimoPedido: number | null
        maximoDesconto: number | null
        apenasPrimeiraCompra: boolean
        automatico: boolean
        ativo: boolean
        freteGratis: boolean
        appSiteTodos: number
        validadeDias: number | null
        fimCupomTimestamp: number | null
        visivelTelaInicial: boolean
        horarioAlmoco: boolean
        exigirFacebookParaDesconto: boolean
        exigirEnderecoUnicoParaDesconto: boolean
        exigirCpfParaDesconto: boolean
        telefoneCliente: string | null
        descricao: string
        olharListaClientes: boolean
    }[]
    deletarIds: number[]
}

export interface CupomSalvo {
    id: number
    cupomId: number
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    ) {
        const d = data as RespostaErroRaw
        return { codErro: d.codErro, mensagem: d.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterCuponsEstabelecimento = async function (
    authorization: string
): Promise<CupomEstabelecimentoItem[] | ErroApi> {
    try {
        const response = await api
            .get<CupomEstabelecimentoItem[] | RespostaErroRaw>("cupom/ObterCuponsEstabelecimento", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization,
                },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as CupomEstabelecimentoItem[]
    } catch (error) {
        RegistrarLogErro(error, "ObterCuponsEstabelecimento", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const salvarCuponsEstabelecimento = async function (
    authorization: string,
    payload: SalvarCuponsPayload
): Promise<CupomSalvo[] | ErroApi> {
    try {
        const response = await api
            .post<CupomSalvo[] | RespostaErroRaw>("cupom/SalvarCuponsEstabelecimento", payload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization,
                },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return (response.data as CupomSalvo[]) ?? []
    } catch (error) {
        RegistrarLogErro(error, "SalvarCuponsEstabelecimento", JSON.stringify(payload))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
